// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"f0847f10a633b653","203":"e6c6a9caf0f28945"}[chunkId] + ".css";
};